module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADKSURBVGhD7Zg9DkFhEEWfROMnLMIWLEBhIRI6jV5pA9agtgU6m9BZBAoJziReIhJad77ck5xMMt3pJlOZgmi8ZmoWeMUTjmKRkR7e8PHyjGNMRwcvWIekjpngHYuImaFjFJmiYxRxjCqOUcUxqjhGFceo4hhVvsUMMR1zfA8JN5iKNu7wM2SFafgWccAupuBXRLyaUuAIFSJij474N8VH9DEFjlDBESo4QgVHqFBERLDF9BFxI6WPCJp4xNQRNQNc4xJbsTCmSKrqCcyG6SlCIUwXAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/forward-filled-50-black.png
// module id = 256
// module chunks = 2 30